import { render, staticRenderFns } from "./monthlyProductStatistics.vue?vue&type=template&id=0c7e3d87&scoped=true"
import script from "./monthlyProductStatistics.vue?vue&type=script&lang=js"
export * from "./monthlyProductStatistics.vue?vue&type=script&lang=js"
import style0 from "./monthlyProductStatistics.vue?vue&type=style&index=0&id=0c7e3d87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7e3d87",
  null
  
)

export default component.exports